var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIllustrationDashboard = function SvgIllustrationDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2441_4199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32813 38C2.78867 36.0927 2.5 34.08 2.5 32C2.5 19.8497 12.3497 10 24.5 10C36.6503 10 46.5 19.8497 46.5 32C46.5 34.08 46.2113 36.0927 45.6719 38",
    stroke: "#8FCBCF",
    strokeWidth: 3.34,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0278 40C19.0777 38.9385 18.5 37.5367 18.5 36C18.5 32.6863 21.1863 30 24.5 30C27.8137 30 30.5 32.6863 30.5 36C30.5 37.5367 29.9223 38.9385 28.9722 40M28.5 30.1084L34.2917 22.0001",
    stroke: "#6A85B6",
    strokeWidth: 3.34,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2441_4199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

export { SvgIllustrationDashboard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDkiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OSA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI0NDFfNDE5OSkiPgo8cGF0aCBkPSJNMy4zMjgxMyAzOEMyLjc4ODY3IDM2LjA5MjcgMi41IDM0LjA4IDIuNSAzMkMyLjUgMTkuODQ5NyAxMi4zNDk3IDEwIDI0LjUgMTBDMzYuNjUwMyAxMCA0Ni41IDE5Ljg0OTcgNDYuNSAzMkM0Ni41IDM0LjA4IDQ2LjIxMTMgMzYuMDkyNyA0NS42NzE5IDM4IiBzdHJva2U9IiM4RkNCQ0YiIHN0cm9rZS13aWR0aD0iMy4zNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMC4wMjc4IDQwQzE5LjA3NzcgMzguOTM4NSAxOC41IDM3LjUzNjcgMTguNSAzNkMxOC41IDMyLjY4NjMgMjEuMTg2MyAzMCAyNC41IDMwQzI3LjgxMzcgMzAgMzAuNSAzMi42ODYzIDMwLjUgMzZDMzAuNSAzNy41MzY3IDI5LjkyMjMgMzguOTM4NSAyOC45NzIyIDQwTTI4LjUgMzAuMTA4NEwzNC4yOTE3IDIyLjAwMDEiIHN0cm9rZT0iIzZBODVCNiIgc3Ryb2tlLXdpZHRoPSIzLjM0IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNDQxXzQxOTkiPgo8cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";